import { render, staticRenderFns } from "./LunchImageCarousel.vue?vue&type=template&id=01257f68&scoped=true&"
import script from "./LunchImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./LunchImageCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./LunchImageCarousel.vue?vue&type=style&index=0&id=01257f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01257f68",
  null
  
)

export default component.exports